import './dot-prod.css';
import 'swiper/css';
import { Swiper, Navigation, Keyboard, A11y } from 'swiper';

export default () => {
    const init = () => {
        if (!customElements.get("dots-slider")) {
            customElements.define("dots-slider", DotSlider);
        }
    };

    class DotSlider extends HTMLElement {
        constructor() {
            super();
            this.mainSlider = this.querySelector(".carousel");
        }

        connectedCallback() {
            const swiper = new Swiper(this.mainSlider, {
                modules: [Navigation, Keyboard, A11y],
                spaceBetween: 0,
                slidesPerView: 1,
                a11y: { enabled: true },
                keyboard: { enabled: true, onlyInViewport: true },
                navigation: {
                    nextEl: ".swiper-button-next-dots",
                    prevEl: ".swiper-button-prev-dots",
                },
            });

            const dots = this.querySelectorAll('.image-products__dot');

            dots.forEach((el) => {
                // Ensure each dot is keyboard and screen reader accessible
                el.setAttribute("role", "tab");
                el.setAttribute("tabindex", "0");
                el.setAttribute("aria-selected", "false");

                el.addEventListener('click', (e) => {
                    e.stopPropagation();
                    this.activateDot(el, swiper);
                });

                // Keyboard support (Enter / Space)
                el.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        el.click();
                    }
                });
            });

            const mainImage = this.querySelector('.image-products');
            if (mainImage) {
                mainImage.addEventListener('click', () => {
                    this.removeActive();
                    dots.forEach((el) => {
                        el.classList.remove('active-dot');
                        el.setAttribute("aria-selected", "false");
                    });
                });
            }
        }

        activateDot(el, swiper) {
            this.removeActive();

            const productDetail = el.querySelector('.image-products__dot-info');
            const productIndex = productDetail.getAttribute('id');

            productDetail.classList.add('active');
            el.classList.add('active-dot');
            el.setAttribute("aria-selected", "true");

            swiper.slideTo(productIndex);

            // Move focus to corresponding slide for accessibility
            const slideEl = this.mainSlider.querySelector(`#${productIndex}`);
            if (slideEl) slideEl.focus();
        }

        removeActive() {
            this.querySelectorAll('.image-products__dot-info').forEach((activeElement) => {
                activeElement.classList.remove('active');
            });
            const dots = this.querySelectorAll('.image-products__dot');
            dots.forEach((el) => {
                el.classList.remove('active-dot');
                el.setAttribute("aria-selected", "false");
            });
        }
    }

    init();
};
